interface SkeletonProps {
  lines?: number;
  isLoading?: boolean;
  children?: React.ReactNode;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  lines = 3,
  isLoading = true,
  children,
}) => {
  if (isLoading) {
    return (
      <div className="rounded-md border border-secondary bg-background p-4">
        {[...Array(lines)].map((_, i) => (
          <div key={i} className="my-2 h-4 animate-pulse rounded bg-tertiary" />
        ))}
      </div>
    );
  }
  return children;
};
